export const CAMPAIGN_NAME = "FXTM Gold Drop '26";
export const CHANNEL_HANDLE = "@fxtm.africa";
export const CHANNEL_URL = "https://youtube.com/@fxtm.africa";
export const SUBSCRIBE_URL = "https://youtube.com/@fxtm.africa?sub_confirmation=1";
export const SHORT_URL = "https://youtube.com/shorts/QgxL7lWhNXQ";
export const EMBED_URL = "https://www.youtube.com/embed/QgxL7lWhNXQ?rel=0&modestbranding=1";
export const GIVEAWAY_DEADLINE = new Date("2026-10-03T22:50:00Z").getTime();
